import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  createLandingSliderRequest,
  getLandingSliders,
  removeLandingSlider,
  updateLandingSliderRequest,
} from "../../../../services/api/landing/landingSlider/landingSliderApi";

const getLang = () =>
  localStorage.getItem("language") === "ar" ? "ar" : "en";

const toastMessages = {
  add: {
    en: "Slider created successfully!",
    ar: "تم إنشاء السلايدر بنجاح!",
  },
  addError: {
    en: "Failed to create slider.",
    ar: "فشل في إنشاء السلايدر.",
  },
  update: {
    en: "Slider updated successfully!",
    ar: "تم تحديث السلايدر بنجاح!",
  },
  updateError: {
    en: "Failed to update slider.",
    ar: "فشل في تحديث السلايدر.",
  },
  delete: {
    en: "Slider deleted successfully!",
    ar: "تم حذف السلايدر بنجاح!",
  },
  deleteError: {
    en: "Failed to delete slider.",
    ar: "فشل في حذف السلايدر.",
  },
};

export const fetchLandingSliders = createAsyncThunk(
  "landingSliders/fetchLandingSliders",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getLandingSliders();
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to fetch landing sliders");
    }
  },
);

export const createLandingSlider = createAsyncThunk(
  "landingSliders/createLandingSlider",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createLandingSliderRequest(formData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to create landing slider");
    }
  },
);

export const updateLandingSlider = createAsyncThunk(
  "landingSliders/updateLandingSlider",
  async ({ sliderId, formData }, { rejectWithValue }) => {
    try {
      const response = await updateLandingSliderRequest(sliderId, formData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue("Failed to update landing slider");
    }
  },
);

export const deleteLandingSlider = createAsyncThunk(
  "landingSliders/deleteLandingSlider",
  async (sliderId, { rejectWithValue }) => {
    try {
      await removeLandingSlider(sliderId);
      return sliderId;
    } catch (error) {
      return rejectWithValue("Failed to delete landing slider");
    }
  },
);

const landingSliderSlice = createSlice({
  name: "landingSliders",
  initialState: {
    sliderData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLandingSliders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLandingSliders.fulfilled, (state, action) => {
        state.loading = false;
        state.sliderData = action.payload;
      })
      .addCase(fetchLandingSliders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createLandingSlider.fulfilled, (state, action) => {
        state.sliderData.push(action.payload);
        toast.success(toastMessages.add[getLang()]);
      })
      .addCase(createLandingSlider.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.addError[getLang()]);
      })
      .addCase(updateLandingSlider.fulfilled, (state, action) => {
        const index = state.sliderData.findIndex(
          (slider) => slider.id === action.payload.id,
        );
        if (index !== -1) {
          state.sliderData[index] = action.payload;
        }
        toast.success(toastMessages.update[getLang()]);
      })
      .addCase(updateLandingSlider.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.updateError[getLang()]);
      })
      .addCase(deleteLandingSlider.fulfilled, (state, action) => {
        state.sliderData = state.sliderData.filter(
          (slider) => slider.id !== action.payload,
        );
        toast.success(toastMessages.delete[getLang()]);
      })
      .addCase(deleteLandingSlider.rejected, (state, action) => {
        state.error = action.payload;
        toast.error(toastMessages.deleteError[getLang()]);
      });
  },
});

export default landingSliderSlice.reducer;
